export const mockFormSubmission = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock form submission:', formData);
      resolve({
        success: true,
        message: 'Solicitação enviada com sucesso! Entraremos em contato em até 24h.'
      });
    }, 1000);
  });
};

export const clientLogos = [
  { name: 'Logística Brasil', sector: 'Logística' },
  { name: 'Hospital Central', sector: 'Hospitalar' },
  { name: 'Educação+', sector: 'Educação' },
  { name: 'Indústria Prime', sector: 'Indústria' },
  { name: 'Atacado Nacional', sector: 'Atacado' },
  { name: 'Finance Corp', sector: 'Financeiro' }
];

export const testimonials = [
  {
    quote: 'A redundância da TMC eliminou nossos problemas de downtime. Com a diversidade de meio, temos certeza que nossa operação está protegida.',
    author: 'Carlos Silva',
    position: 'Gerente de TI',
    company: 'Logística Brasil'
  },
  {
    quote: 'O failover automático é imperceptível. Nossas linhas de produção nunca sofrem com problemas de conectividade. Investimento que se paga em dias.',
    author: 'Fernanda Costa',
    position: 'Diretora de Operações',
    company: 'Hospital Central'
  },
  {
    quote: 'Excelente suporte técnico e infraestrutura de ponta. A TMC entende as necessidades críticas da nossa operação industrial.',
    author: 'Roberto Martins',
    position: 'CTO',
    company: 'Indústria de Manufatura'
  }
];

export const stats = [
  { value: '15+', label: 'Anos de Experiência' },
  { value: '500+', label: 'Clientes Atendidos' },
  { value: '99,99%', label: 'Disponibilidade' },
  { value: '24/7', label: 'Suporte Técnico' }
];

export const services = [
  {
    title: 'Link IP Dedicado',
    description: 'Internet de altíssima velocidade com banda 100% garantida, velocidade simétrica e múltiplas conexões.',
    features: [
      'Banda garantida',
      'Velocidade simétrica',
      'Múltiplas conexões',
      'SLA 99,99%'
    ],
    color: 'from-blue-500 to-blue-600'
  },
  {
    title: 'Telefonia IP',
    description: 'Solução de voz corporativa com qualidade de áudio cristalina e recursos avançados.',
    features: [
      'Ramais ilimitados',
      'Conferência integrada',
      'Gravação de chamadas',
      'IVR customizado'
    ],
    color: 'from-purple-500 to-purple-600'
  },
  {
    title: 'Firewall Corporativo',
    description: 'Proteção avançada com UTM (Unified Threat Management) para segurança em camadas.',
    features: [
      'Bloqueio de ameaças',
      'Controle de banda',
      'VPN integrada',
      'Logs detalhados'
    ],
    color: 'from-green-500 to-green-600'
  },
  {
    title: 'PABX Virtual',
    description: 'Central telefônica em nuvem com mobilidade total e redução de custos de infraestrutura.',
    features: [
      'Ramais móveis',
      'Integração de unidades',
      'Custo zero de infraestrutura',
      'Escalabilidade'
    ],
    color: 'from-orange-500 to-orange-600'
  }
];